import { IParentPage } from '../../../types/shared';

import {
  getPagesPathRecursively,
  parseNestedParentPages,
} from '../../../utils/urls';

import { Theme } from '../../../tokens';

import { BreadcrumbItem } from './Breadcrumbs.types';

interface ParsedBreadcrumbItem extends BreadcrumbItem {
  pages: ParsedBreadcrumbItem[];
}

const parseBreadcrumbItems = (
  items: ParsedBreadcrumbItem[],
  results: BreadcrumbItem[]
): BreadcrumbItem[] => {
  items.forEach(({ path, label, pages }) => {
    results.push({
      path: `${getPagesPathRecursively(pages, [])}${path}`,
      label,
    });

    parseBreadcrumbItems(pages, results);
  });

  return [...results].reverse();
};

const parseItems = (
  pageName: string,
  parentPage?: IParentPage
): BreadcrumbItem[] => {
  const nestedPages = parseNestedParentPages(parentPage);
  const items = [
    ...parseBreadcrumbItems(nestedPages, []),
    {
      path: '',
      label: pageName,
    },
  ];

  return items;
};

const parseThemeByColor = (backgroundColor: string): Theme => {
  const color = backgroundColor.substring(1, 7);
  const r = parseInt(color.substring(0, 2), 16);
  const g = parseInt(color.substring(2, 4), 16);
  const b = parseInt(color.substring(4, 6), 16);
  const uiColors = [r / 255, g / 255, b / 255];
  const c = uiColors.map((col) => {
    if (col <= 0.03928) {
      return col / 12.92;
    }
    return ((col + 0.055) / 1.055) ** 2.4;
  });
  const L = 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];

  return L > 0.94 ? Theme.DARK : Theme.LIGHT;
};

export { parseItems, parseThemeByColor };
